module.exports = __webpack_public_path__ + "static/media/profile-teams.48c21432.jpg";